import { VALID_USER_ROLES } from '../config/roles.config';
import {
  ACCESS_RIGHTS_ADMIN,
  ACCESS_RIGHTS_MASTER_ADMIN,
} from '../config/role-access.config';

const getUserRolePermission = (role) => {
  let userRights = null;
  if (role === VALID_USER_ROLES.MASTER_ADMIN) {
    userRights = ACCESS_RIGHTS_MASTER_ADMIN;
  } else if (role === VALID_USER_ROLES.ADMIN) {
    userRights = ACCESS_RIGHTS_ADMIN;
  }
  return userRights;
};

export default getUserRolePermission;
